import { forwardRef, type Ref, type SVGProps } from "react";
const IconElectricityFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M24.14 14.354a.5.5 0 0 1 .5.5v1.42c-.006 3.277-1.865 7.015-4.8 8.474v.912a1.926 1.926 0 0 1-1.92 1.92h-.96v1.92h-1.92v-1.92h-.96a1.925 1.925 0 0 1-1.92-1.92v-.912c-2.934-1.458-4.794-5.197-4.8-8.475v-1.42a.5.5 0 0 1 .5-.5zm.753-4.127a1 1 0 0 1 1 1v.989a1 1 0 0 1-1 1H7.107a1 1 0 0 1-1-1v-.99a1 1 0 0 1 1-1zM11.753 2.5c.825 0 1.493.59 1.494 1.317v5.24H10.26v-5.24c0-.727.669-1.317 1.493-1.317m8.4 0c.825 0 1.494.59 1.494 1.317v5.24H18.66v-5.24c0-.727.668-1.317 1.493-1.317"
    />
  </svg>
);
const ForwardRef = forwardRef(IconElectricityFilledSVG);
ForwardRef.displayName = "IconElectricityFilled";
export { ForwardRef as IconElectricityFilled };
